'use client'

import { useState, useEffect } from 'react'
import { Drawer } from '@repo/ui/Drawer'
import { LargeUserIcon } from '@repo/ui/LargeUserIcon'
import { LargeMatterIcon } from '@repo/ui/LargeMatterIcon'
import MUITypography from '@mui/material/Typography'
import MUIAlert from '@mui/material/Alert'
import MUIAlertTitle from '@mui/material/AlertTitle'
import { useMattersStore } from '@repo/store/useMattersStore'
import { MatterDrawerTopTabs } from '@repo/ui/MatterDrawerTopTabs'
import { MatterDrawerClientTab } from '@repo/ui/MatterDrawerClientTab'
import { MatterDrawerMatterTab } from '@repo/ui/MatterDrawerMatterTab'
import { MatterDrawerRelatedMattersTab } from '@repo/ui/MatterDrawerRelatedMattersTab'
import { MatterDrawerClientExtensionsTab } from '@repo/ui/MatterDrawerClientExtensionsTab'
import { MatterDrawerMatterExtensionsTab } from '@repo/ui/MatterDrawerMatterExtensionsTab'

export const MatterDrawer = () => {
  const {
    matterDrawerIsOpen,
    setMatterDrawerIsOpen,
    matterDrawerConflicts,
    matterDrawerClientMatterNo,
    matterDrawerClientNo
  } = useMattersStore()

  const isClientOnly = matterDrawerClientMatterNo === matterDrawerClientNo

  const [selectedTab, setSelectedTab] = useState(isClientOnly ? 'client' : 'matter')

  const changeTab = (e, value) => {
    e.stopPropagation()
    setSelectedTab(value)
  }

  useEffect(() => {
    setSelectedTab(isClientOnly ? 'client' : 'matter')
  }, [matterDrawerIsOpen, matterDrawerClientMatterNo, isClientOnly])

  return (
    <div data-testid="MatterDrawer">
      <Drawer
        isOpen={matterDrawerIsOpen}
        onClose={() => setMatterDrawerIsOpen(false)}
        headingNode={
          <MUITypography variant="h5" sx={{ mb: 0, alignItems: 'center', display: 'flex' }}>
            {isClientOnly ? (
              <LargeUserIcon sx={{ width: '36px', height: '36px', mr: 3, color1: '#5073c3', color2: '#3D517B' }} />
            ) : (
              <LargeMatterIcon sx={{ width: '36px', height: '36px', mr: 3, color2: '#5073c3' }} />
            )}
            {isClientOnly ? 'Client' : 'Matter'} details
          </MUITypography>
        }
      >
        {matterDrawerConflicts ? (
          <MUIAlert severity="info" sx={{ m: '0px 24px 16px' }}>
            <MUIAlertTitle>Conflict details</MUIAlertTitle>
            <ul style={{ paddingLeft: '20px', marginLeft: '-2px' }}>
              {matterDrawerConflicts.map((reason) => (
                <li key={reason}>{reason}</li>
              ))}
            </ul>
          </MUIAlert>
        ) : null}

        <MatterDrawerTopTabs selectedTab={selectedTab} onChange={changeTab} isClientOnly={isClientOnly} />

        <div style={{ height: '100%', overflowX: 'hidden', overflowY: 'scroll' }}>{renderTabContent(selectedTab)}</div>
      </Drawer>
    </div>
  )
}

const renderTabContent = (selectedTab) => {
  switch (selectedTab) {
    case 'matter':
      return <MatterDrawerMatterTab />
    case 'matterExt':
      return <MatterDrawerMatterExtensionsTab />
    case 'client':
      return <MatterDrawerClientTab />
    case 'clientExt':
      return <MatterDrawerClientExtensionsTab />
    case 'related':
      return <MatterDrawerRelatedMattersTab />
    default:
      return null
  }
}
